




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as complianceLinks from "@/data/sources/complianceLinks"
import {executeQuery} from "@/data/repos/query"

@Component({
  components: {
    DataGrid,
  },
})
export default class ComplianceFailingElementsDrillDown extends Vue {
  @Prop() public args!: { locationId: number }
  public fields = [
    {name: 'ElementDescription', title: 'Element', dataType: 'Text', sort: 1, component: DataGridLink, callback: complianceLinks.element},
    {name: 'BuildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.building},
    {name: 'Code', title: 'Code', dataType: 'Text', sort: 1},
    {name: 'Reason', title: 'Reason', dataType: 'Text', sort: 1},
    {name: 'expirydate', title: 'Expiry Date', dataType: 'Text', sort: 1},
    {name: 'responsiblePerson', title: 'Responsible Person', dataType: 'Text', sort: 1},
    {name: 'riskLabel', title: 'Risk', dataType: DataType.Text, sort: 1},
    {name: 'Risk', title: 'Risk Value', dataType: DataType.Number, sort: 1},
  ]

  public getData(offset: number = 0, limit: number = 250) {
    return executeQuery("idr", "compliance.failingElementsDrillDown",
      {locationId: this.args.locationId},
      undefined,
      offset, limit)
  }
}
